import SignupForm from "./components/SignupForm";

const Signup = () => {
  return <SignupForm />;
};

export default Signup;
